const state = {

  videoToken: '',//摄像头token

}
export default state



// WEBPACK FOOTER //
// ./src/store/state.js